import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  Algo,
  AlgoStateDebugMessage,
  LimitOrderConfiguration,
} from "../../types";

export const getDebugMessage = (
  algo: Algo<LimitOrderConfiguration>
): AlgoStateDebugMessage | undefined => {
  switch (algo.state.state) {
    case "Stopped":
    case "Crashed":
      return {
        algo_id: algo.algo_id,
        algo_state: algo.state,
      };
  }
  return undefined;
};

const AlgoDebugMessageButton = (props: {
  dbgMessage: AlgoStateDebugMessage;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const CopyToClipBoard = (content: any) => {
    const json = JSON.stringify(content);
    navigator.clipboard.writeText(json);
    setTitle("Copied!");
    setTimeout(() => {
      setTitle(props.dbgMessage.algo_state.message);
    }, 1000);
  };

  const [title, setTitle] = React.useState(props.dbgMessage.algo_state.message);

  return (
    <div>
      <Tooltip title={title}>
        <IconButton onClick={() => CopyToClipBoard(props.dbgMessage)}>
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export { AlgoDebugMessageButton };
